var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-sidebar" },
    _vm._l(_vm.accordions, function(accordion, index) {
      return _c(
        "DrawerAccordion",
        {
          key: index,
          attrs: {
            id: "accordion-" + index,
            title: accordion.title,
            openByDefault: false
          }
        },
        [
          _c("div", {
            staticClass:
              "onboarding-sidebar__accordion-content typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(accordion.content) }
          })
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }